function getFilter(filter) {
  const filters = {
    last: (ranking) => getLastUsers(ranking),
    first: (ranking) => getFirstUsers(ranking),
    around: (ranking, userData) => getAroundUsers(ranking, userData),
    search: (ranking, userData, search) => getSearchedUsers(ranking, userData, search),
    attackable: (ranking, userData) => getAttackablesUsers(ranking, userData),
  }

  return filters[filter]
}
export function getLastUsers(ranking) {
  const limit = 8
  const resversedRanking = ranking.map((user, i) => ranking[ranking.length - (i + 1)])

  return resversedRanking
    .filter((w, i) => {
      return i <= limit
    })
    .reverse()
}

export function getFirstUsers(ranking) {
  const limit = 8

  return ranking.filter((w, i) => {
    return i <= limit
  })
}
export function obfuscated(name, currentUser) {
  if (name == 'undefined' || name == undefined) {
    name = 'Martian'
  }
  if (currentUser.name == name) {
    return name
  }
  let obfuscated = name.charAt(0) + '*******' + name.charAt(name.length - 1)
  return obfuscated
}
export function getAroundUsers(ranking, userData) {
  const limit = 4
  const position = userData.position - 1

  return ranking.filter((w, i) => {
    return i <= position + limit && i >= position - limit
  })
}

export function getAttackablesUsers(ranking, userData) {
  const playersAttacked = userData.playersAttacked
  return userData.batd >= 2
    ? []
    : ranking.filter((user) => {
        return !playersAttacked[user.licenseId] && user.batp < 2
      })
}

export function getSearchedUsers(ranking, userData, search) {
  if (!search) return ranking

  return ranking.filter((user) => {
    return (
      user.name.toLowerCase().includes(search.toLowerCase()) ||
      (user.colonyName && user.colonyName.toLowerCase().includes(search.toLowerCase()))
    )
  })
}

export function getFilteredUsers(ranking, filter, userdata, search) {
  if (!filter) return ranking

  const filterRanking = getFilter(filter)
  return filterRanking(ranking, userdata, search)
}
export function getNameFromLicense(list, id) {
  return list[list.findIndex((x) => x.licenseId == id)]
}

export function getFederationRanking(ranking, federation) {
  return ranking
    .filter((user) => user.federationId == federation.name)
    .sort((a, b) => {
      return a.settlers < b.settlers ? 1 : a.settlers == b.settlers ? 0 : -1
    })
    .map((d, i) => {
      return { ...d, position: i + 1 }
    })
}
